import { Dialog, DialogContent } from '@mui/material'
import React from 'react'
import CreatEdit from './CreateEdit'
import  './vehicleModel.css';

function VehicleModelPopUp({productId,handleClose,riskFactorname,apiUrl,setNewValue,makeId}) {
  return (
    <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={true}
        onClose={handleClose}
      >
       
        <DialogContent className="modalContainer">
          <CreatEdit makeId={makeId}   setNewValue={setNewValue}  closeCreateEditForm={handleClose} vehichleModelEditDatas={null} editStatus={false} />
        </DialogContent>
       
      </Dialog>
  )
}

export default VehicleModelPopUp